import { useState } from "react";
import Swal from "sweetalert2";

export default function AddUserModal({
  open,
  onClose,
  token,
  usermanId,
  onSuccess,
}) {
  const [form, setForm] = useState({
    name: "",
    password: "",
    group_name: "default",
    shared_users: 1,
    disabled: false,
  });
  const [loading, setLoading] = useState(false);
  console.log(usermanId);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.password) {
      return Swal.fire(
        "Validasi gagal",
        "Username dan password wajib diisi",
        "warning"
      );
    }

    setLoading(true);
    try {
      const res = await fetch("https://api.wifikamu.my.id/userman-user-add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          userman_id: usermanId,
          newUser: {
            username: form.name,
            password: form.password,
            group: form.group_name,
            sharedUsers: Number(form.shared_users),
          },
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.message || "Gagal menambahkan user");
      }

      Swal.fire("Berhasil", data.message, "success");
      onSuccess?.();
      onClose();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-slate-800 w-full max-w-md rounded-xl shadow-lg">
        <div className="px-6 py-4 border-b dark:border-slate-700">
          <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
            Add User Manager User
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm mb-1 dark:text-slate-300">
              Username
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:bg-slate-900 dark:border-slate-700"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-1 dark:text-slate-300">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:bg-slate-900 dark:border-slate-700"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-1 dark:text-slate-300">
              Group
            </label>
            <input
              name="group_name"
              value={form.group_name}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:bg-slate-900 dark:border-slate-700"
            />
          </div>

          <div>
            <label className="block text-sm mb-1 dark:text-slate-300">
              Shared Users
            </label>
            <input
              type="number"
              min="1"
              name="shared_users"
              value={form.shared_users}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:bg-slate-900 dark:border-slate-700"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              name="disabled"
              checked={form.disabled}
              onChange={handleChange}
            />
            <span className="text-sm dark:text-slate-300">Disabled</span>
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-slate-200 dark:bg-slate-700"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 rounded bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50"
            >
              {loading ? "Saving..." : "Add User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
